/* eslint-disable */
import $ from 'jquery';
import Cookies from 'js-cookie'
import BaseModule from './BaseModule';

export default class ViewToggle extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'ViewToggle');

    const wrapper = $(el).find('.vms-item-content');

    this.initCookie();
    this.init(wrapper);
  }

  setList() {
    $('.btn-view-list').addClass('active');
    $('.btn-view-grid').removeClass('active');
    $('.acc-item-listing').addClass('view-listing');
  }

  setGrid() {
    $('.btn-view-grid').addClass('active');
    $('.btn-view-list').removeClass('active');
    $('.acc-item-listing').removeClass('view-listing');
  }

  initCookie() {
    const view = Cookies.get('product-view');
    if (view === 'list') {
      this.setList();
    } else if (view === 'grid') {
      this.setGrid();
    }
  }

  init(wrapper) {
    let _this = this;
    wrapper.on('click', '.btn-view-list', function(e) {
      e.preventDefault();
      _this.setList();
      Cookies.set('product-view', 'list');
    })

    wrapper.on('click', '.btn-view-grid', function(e) {
      e.preventDefault();
      _this.setGrid();
      Cookies.set('product-view', 'grid');
    })
  }
}
